// src/frontend/js/modern/shared/ui-helpers.js

/**
 * Global map to store loading timers per element.
 */
const _loadingTimers = new WeakMap();

export function showError(message) {
	if (typeof window.wlfmc_toastr !== 'undefined' && String(message).trim() !== '') {
		return window.wlfmc_toastr.error(message);
	}
	console.error('[WLFMC] Error:', message);
	return null;
}

export function showSuccess(message) {
	if (typeof window.wlfmc_toastr !== 'undefined' && String(message).trim() !== '') {
		return window.wlfmc_toastr.success(message);
	}
	console.log('[WLFMC] Success:', message);
	return null;
}

export function showInfo(message) {
	if (typeof window.wlfmc_toastr !== 'undefined' && String(message).trim() !== '') {
		return window.wlfmc_toastr.info(message);
	}
	console.log('[WLFMC] Info:', message);
	return null;
}

export function block(element, loaderUrl = null) {
	const el = typeof element === 'string' ? document.querySelector(element) : element;
	if (!el) return;
	if (window.wlfmc_l10n?.enable_ajax_loading === '0') {
		el.style.opacity = '0.6';
		return;
	}
	const url = loaderUrl || window.wlfmc_l10n?.ajax_loader_url || '';
	el.style.opacity = '0.6';
	el.style.position = 'relative';
	const overlay = document.createElement('div');
	overlay.className = 'wlfmc-block-overlay';
	overlay.style.cssText = `position:absolute;top:0;left:0;width:100%;height:100%;background:transparent url(${url}) no-repeat center;background-size:40px 40px;z-index:9999;`;
	el.appendChild(overlay);
}


export function unblock(element) {
	const el = typeof element === 'string' ? document.querySelector(element) : element;
	if (!el) return;
	el.style.opacity = '1';
	el.querySelectorAll('.wlfmc-block-overlay').forEach(ov => ov.remove());
	document.querySelectorAll('.tooltip__expanded').forEach(t => {
		t.className = 'tooltip__hidden';
	});
}


/**
 * Show visual loading state on an element for a fixed duration (500ms).
 * Returns a promise that resolves when the loading animation completes.
 *
 * @param {HTMLElement} element - The DOM element to apply loading state to.
 * @returns {Promise<void>}
 */
export async function loading(element) {
	if (!element) return Promise.resolve();

	const isEnabled = window.wlfmc_l10n?.enable_ajax_loading === '1' || window.wlfmc_l10n?.enable_ajax_loading === true;

	if (!isEnabled) {
		return Promise.resolve();
	}

	// Clear any existing timer for this element
	if (_loadingTimers.has(element)) {
		clearTimeout(_loadingTimers.get(element));
		_loadingTimers.delete(element);
	}

	// Add visual classes IMMEDIATELY
	const hasIcon = element.querySelector('i') !== null;
	element.classList.add('wlfmc-action', hasIcon ? 'wlfmc-loading' : 'wlfmc-loading-alt');

	// Create a promise that resolves after 500ms
	return new Promise((resolve) => {
		const timerId = setTimeout(() => {
			unloading(element);
			_loadingTimers.delete(element);
			resolve();
		}, 500);

		_loadingTimers.set(element, timerId);

	});
}

/**
 * Remove loading state from an element immediately.
 *
 * @param {HTMLElement} element - The DOM element to remove loading state from.
 */
export function unloading(element) {
	if (!element) return;

	if (_loadingTimers.has(element)) {
		clearTimeout(_loadingTimers.get(element));
		_loadingTimers.delete(element);
	}

	element.classList.remove('wlfmc-loading', 'wlfmc-loading-alt');
}


export function tableBlock() {
	document.querySelectorAll('.wlfmc-wishlist-table-wrapper, .wlfmc-save-for-later-table-wrapper').forEach(el => {
		block(el);
	});
}


export function triggerDomEvent(target, eventName, detail = {}) {
	const el = typeof target === 'string' ? document.querySelector(target) : target;
	if (!el) return;
	const event = new CustomEvent(eventName, {
		bubbles: true,
		cancelable: true,
		detail
	});
	el.dispatchEvent(event);
}


export function triggerBodyEvent(eventName, detail = {}) {
	triggerDomEvent(document.body, eventName, detail);
}

export function ensurejQuery(el) {
	const $ = window.jQuery;
	if (!$ || !el) return el;
	return (el instanceof $) ? el : $(el);
}

export function ensureNative(el) {
	const $ = window.jQuery;
	if (!$ || !el) return el;
	return (el instanceof $) ? el[0] : el;
}
